import { Band, Folder, Microphone, MusicNote } from '@tunasong/icons'
import type { FC, ReactNode } from 'react'
import styles from './start-tiles.module.css'

export interface StartTilesProps {
  onNewSong(): void
  /** Creates a band space */
  onNewBand(): void
  /** Creates a space */
  onNewProject(): void
  onRecord(): void
}

interface Tile {
  title: string
  subtitle: string
  icon: ReactNode
  onClick(): void
}

/**
 * First-run Continue: four equal-weight starting points. A band and a project are starting points equal to a
 * song, not secondary to it.
 */
export const StartTiles: FC<StartTilesProps> = props => {
  const { onNewSong, onNewBand, onNewProject, onRecord } = props

  const tiles: Tile[] = [
    { title: 'Write a song', subtitle: 'Lyrics, chords and sections', icon: <MusicNote />, onClick: onNewSong },
    { title: 'Set up your band', subtitle: 'Shared songs, setlists and gigs', icon: <Band />, onClick: onNewBand },
    { title: 'Start a project', subtitle: 'An album, a course, a collection', icon: <Folder />, onClick: onNewProject },
    { title: 'Record an idea', subtitle: "Catch a riff before it's gone", icon: <Microphone />, onClick: onRecord },
  ]

  return (
    <div className={styles.tiles}>
      {tiles.map(tile => (
        <button key={tile.title} type="button" className={styles.tile} onClick={tile.onClick}>
          <span className={styles.icon} aria-hidden="true">
            {tile.icon}
          </span>
          <span className={styles.text}>
            <span className={styles.title}>{tile.title}</span>
            <span className={styles.subtitle}>{tile.subtitle}</span>
          </span>
        </button>
      ))}
    </div>
  )
}

export default StartTiles
